<ng-container *ngIf="branch">
  <div class="mb-3">
    <strong>{{ branch.LocationName }}</strong> <br />
    {{ branch.Address }}<br />
    {{ branch.City }}, {{ branch.State }}
    {{ branch.Zip }}
    <br />
    <a [href]="branch ? setGoogleMapsSearch(branch) : ''" target="_blank">
      View Map
    </a>
  </div>

  <hr class="hr-style" />

  <p>
    <a href="tel:+{{ branch.RawPhone }}">
      {{ branch.Phone }}
    </a>
  </p>
  <p class="mb-0">
    <strong>HOURS:</strong><br />
    {{ branch.Hours }}
  </p>
</ng-container>
